import './components';
import { makeCarousel } from '../../auto/lightCarousel';
import { autoServiceApiV2 } from '../../auto/services/autoServiceApiV2';
import { updateTimeRemaining } from '../../showroom_performance/utils/utils';

window.makeCarousel = makeCarousel;
window.autoServiceApiV2 = autoServiceApiV2;
window.updateTimeRemaining = updateTimeRemaining;
